import { render, staticRenderFns } from "./TeamAuditDocument.vue?vue&type=template&id=a31e340a&scoped=true"
import script from "./TeamAuditDocument.vue?vue&type=script&lang=js"
export * from "./TeamAuditDocument.vue?vue&type=script&lang=js"
import style0 from "./TeamAuditDocument.vue?vue&type=style&index=0&id=a31e340a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31e340a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a31e340a')) {
      api.createRecord('a31e340a', component.options)
    } else {
      api.reload('a31e340a', component.options)
    }
    module.hot.accept("./TeamAuditDocument.vue?vue&type=template&id=a31e340a&scoped=true", function () {
      api.rerender('a31e340a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Before/ProjectInfo/TeamAuditDocument.vue"
export default component.exports